module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('h1', {
    staticClass: "pt-5"
  }, [_vm._v("Outils d'administration")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dbmanagement"
    }
  }, [_vm._v("\n          Gestion de la base de données\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/moderation"
    }
  }, [_vm._v("\n          Modération de l'activité\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27130826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administration.vue
// module id = 453
// module chunks = 1